export const LARAVEL_API_URL = "https://optech.kz:8000/api";
export const LARAVEL_URL = 'https://optech.kz:8000';